import React from 'react';

export default class PanelTop extends React.Component{
    render() {
        return (
            <nav className="page-top">
                <li className='adex-logo' />
                {this.props.children}
            </nav>
        );
    }
}
export {PanelTop};


// WEBPACK FOOTER //
// ./src/components/PanelPages/PanelTop.jsx